import { Link, useLocation } from "react-router-dom";
import { routes } from "@/app/navigation/routes";
import styles from "./Header.module.css";
import { useCallback, useState } from "react";
import { AddressSelectPill } from "@/shared/components/common/AddressSelectPill";
import { useAddressListViewModel } from "@/shared/components/common/AddressSelectPill/AdrressListviewmodel";
import { useNavigate } from "react-router-dom";
import { useAddress } from "@/shared/hooks";
import andyHdLogo from "@/assets/andyhdlogo.png";

export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomeScreen = location.pathname === routes.homepage;
  const isNewsScreen = location.pathname === routes.newsFeed;
  const showAddressPill = isHomeScreen || isNewsScreen;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { selectedAddress, setSelectedAddress } = useAddress();
  const { options: addressOptions } = useAddressListViewModel();

  // useEffect(() => {
  //   if (selectedAddress) return;
  //   const first = addressOptions.at(0);
  //   if (!first) return;
  //   setSelectedAddress(first.value);
  // }, [addressOptions, selectedAddress, setSelectedAddress]);

  const getClassName = useCallback(
    (path: string) => {
      return location.pathname === path || location.pathname.startsWith(path)
        ? styles.navLinkActive
        : styles.navLink;
    },
    [location.pathname]
  );

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      {isMobileMenuOpen && (
        <div className={styles.mobileMenuOverlay} onClick={closeMobileMenu} aria-hidden="true" />
      )}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          {/* Left: Logo */}
          <Link
            to={routes.home}
            className={styles.logoSection}
            onClick={closeMobileMenu}
            aria-label="Go to home"
          >
            <div className={styles.logoIcon} aria-hidden="true">
              <img src={andyHdLogo} alt="Andy logo" className={styles.andyLogo} />
            </div>
          </Link>

          {/* Center: Navigation (pill) */}
          <div className={styles.navSlot}>
            <nav
              className={`${styles.nav} ${isMobileMenuOpen ? styles.navOpen : ""}`}
              aria-label="Primary"
            >
              <Link
                to={routes.homepage}
                className={getClassName(routes.homepage)}
                onClick={closeMobileMenu}
              >
                Home
              </Link>
              <Link
                to={routes.propertiesSearch}
                className={getClassName(routes.propertiesSearch)}
                onClick={closeMobileMenu}
              >
                Properties
              </Link>
              <Link
                to={routes.newsFeed}
                className={getClassName(routes.newsFeed)}
                onClick={closeMobileMenu}
              >
                News
              </Link>
              <Link
                to={routes.referAndEarn}
                className={getClassName(routes.referAndEarn)}
                onClick={closeMobileMenu}
              >
                Refer a Friend
              </Link>
              <Link
                to={routes.settings}
                className={getClassName(routes.settings)}
                onClick={closeMobileMenu}
              >
                Settings
              </Link>

              <div className={styles.drawerActions}>
                <Link
                  to={routes.settingsAccount}
                  className={styles.drawerActionLink}
                  onClick={closeMobileMenu}
                >
                  Profile
                </Link>
                <button
                  type="button"
                  className={styles.drawerActionButton}
                  onClick={() => {
                    closeMobileMenu();
                    navigate(routes.notifications);
                  }}
                >
                  Notifications
                </button>
              </div>
            </nav>
          </div>

          {/* Right: Address + Icons + Mobile menu button */}
          <div className={styles.rightActions}>
            {showAddressPill && (
              <div className={styles.addressPillWrap}>
                <AddressSelectPill
                  value={selectedAddress}
                  onValueChange={(next: string) => {
                    if (next === "__add__") {
                      navigate(routes.propertiesSearch);
                      return;
                    }
                    setSelectedAddress(next);
                  }}
                  visibleOptionsCount={5}
                  options={[
                    { value: "__add__", label: "Add a New property" },
                    ...(addressOptions.length
                      ? addressOptions
                      : [{ value: "", label: "No addresses found" }]),
                  ]}
                  ariaLabel="Select address"
                />
              </div>
            )}

            <Link to={routes.settingsAccount} className={styles.iconButton} aria-label="Profile">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M20 21a8 8 0 1 0-16 0"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            </Link>

            <button
              className={styles.iconButton}
              type="button"
              aria-label="Notifications"
              onClick={() => navigate(routes.notifications)}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 7h18s-3 0-3-7Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.73 21a2 2 0 0 1-3.46 0"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>

            {/* Hamburger Menu Button (mobile) */}
            <button
              className={styles.mobileMenuButton}
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
              aria-expanded={isMobileMenuOpen}
              type="button"
            >
              <span
                className={`${styles.hamburgerLine} ${isMobileMenuOpen ? styles.hamburgerOpen : ""}`}
              ></span>
              <span
                className={`${styles.hamburgerLine} ${isMobileMenuOpen ? styles.hamburgerOpen : ""}`}
              ></span>
              <span
                className={`${styles.hamburgerLine} ${isMobileMenuOpen ? styles.hamburgerOpen : ""}`}
              ></span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
};
